export enum Language {
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
}
